module.exports = __webpack_public_path__ + "static/media/cross.8850902f.svg";